import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from "vue";
import Utils from "@/utils/utilities";
import DOMPurify from "dompurify";
import VRuntimeTemplate from "vue3-runtime-template";
import unescape from "lodash/unescape";

export default /*#__PURE__*/_defineComponent({
  __name: 'customDescriptionContent',
  props: {
  description: {
    type: String,
    default: "",
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  classLine: {
    type: String,
    default: "tw-text-[13px] tw-font-[400] tw-text-[#878787]",
  },
  isRecommendation: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const descriptionContent = ref(props.description);
let heading = "";
const processData = async () => {
  let newHtml = replaceText(descriptionContent.value);
  newHtml = checkForHeading(newHtml);
  descriptionContent.value = heading + newHtml;
};

DOMPurify.addHook("uponSanitizeAttribute", function (node, data) {
  if (data.attrName === "target") {
    data.keepAttr = true; // Keep the target attribute
  }
});
const getSafeHTML = (htmlText: string) => {
  const unescapeData = unescape(htmlText);
  const html = DOMPurify.sanitize(unescapeData, { ADD_ATTR: ["target"] });
  return html;
};

// With a heading (if there is a # in front of the first line of text, make it a heading)
const checkForHeading = (htmlText: string) => {
  if (!htmlText) return "";
  let lines = htmlText.split("\n");
  if (lines[0].startsWith("#")) {
    heading =
      lines[0].replace(
        "#",
        '<div class="tw-text-[14px] tw-font-[500] tw-text-[#211F58] tw-mb-[10px]">',
      ) + " </div>";
    lines.shift();
  }
  return lines
    .map((line) => `<div class=" ${props.classLine}"> ${line} </div> `)
    .join("\n");
};

// With Links (if they have the format of [placeholder text](url), open in a new tab)
const replaceText = (htmlText: string) => {
  if (!htmlText) return "";
  const regex = /\[(.*?)\]\(([^)]+)\)/g;
  return htmlText.replace(
    regex,
    '<a target="_blank" href="$2" rel="noopener noreferrer">$1</a>',
  );
};
onMounted(() => {
  if (!props.isRecommendation) processData();
});

watch(
  () => props.description,
  (newValue) => {
    if (newValue) {
      descriptionContent.value = newValue;
      if (!props.isRecommendation) processData();
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-p-[15px]", __props.customClass])
  }, [
    _createVNode(_unref(VRuntimeTemplate), {
      template: getSafeHTML(descriptionContent.value)
    }, null, 8, ["template"])
  ], 2))
}
}

})